import { useMemo } from 'react'
import { DRAWER_WIDTH } from 'config'

// material-ui
import { useTheme } from '@mui/material/styles'
import { AppBar, Toolbar, useMediaQuery, IconButton } from '@mui/material'

// project import
import AppBarStyled from './AppBarStyled'
import HeaderContent from './HeaderContent'

import { MenuOrientation, ThemeMode } from 'config'
import useConfig from 'hooks/useConfig'
import { useSelector } from 'store'
import { RightSquareOutlined, LeftSquareOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { openDrawer } from 'store/reducers/menu'

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const createStyles = (theme) => ({
  toolbar: {
    minHeight: 'auto',
    height: 'auto',
    px: { xs: '16px' },
    py: { xs: '12px' },
  },
  icon: {
    color: theme.palette.text.secondary,
  },
})

const Header = () => {
  const theme = useTheme()
  const styles = createStyles(theme)
  const downLG = useMediaQuery(theme.breakpoints.down('lg'))
  const { menuOrientation } = useConfig()
  const dispatch = useDispatch()

  const menu = useSelector((state) => state.menu)
  const { drawerOpen } = menu

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG

  // header content
  const headerContent = useMemo(() => <HeaderContent />, [])

  // common header
  const mainHeader = (
    <Toolbar sx={styles.toolbar}>
      {!isHorizontal ? (
        <IconButton
          aria-label="open drawer"
          onClick={() => dispatch(openDrawer(!drawerOpen))}
          edge="start"
          color="secondary"
          variant="text"
          sx={{
            bgcolor: 'transparent',
            p: { xs: 0 },
            display: { lg: 'none' },
          }}
        >
          {!drawerOpen ? (
            <RightSquareOutlined style={styles.icon} />
          ) : (
            <LeftSquareOutlined style={styles.icon} />
          )}
        </IconButton>
      ) : null}
      {headerContent}
    </Toolbar>
  )

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      bgcolor: theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.50',
      zIndex: 1200,
      width: isHorizontal
        ? '100%'
        : drawerOpen
        ? `calc(100% - ${DRAWER_WIDTH}px)`
        : { xs: '100%', lg: 'calc(100% - 60px)' },
      // boxShadow: theme.customShadows.z1
    },
  }

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  )
}

export default Header
